/* unplugin-vue-components disabled */import script from "./Navigation.vue?vue&type=script&lang=ts&setup=true"
export * from "./Navigation.vue?vue&type=script&lang=ts&setup=true"

import "./Navigation.vue?vue&type=style&index=0&id=3558af03&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3558af03"]])

export default __exports__